import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStreamsHeroData, streamsHeroDataSelector } from '../../../StreamsPage/StreamsPage.duck';
import { Heading, IconCollection, NamedLink } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './StreamsHero.module.css';
import { extractImageKey } from '../../../../util/data';

const StreamsHero = () => {
    const dispatch = useDispatch();
    const heroData = useSelector(streamsHeroDataSelector);

    const { title, background_image, description } = heroData?.[0] || {};

    useEffect(() => {
        dispatch(fetchStreamsHeroData());
    }, []);

    const gumletCDNBase = process.env.REACT_APP_GUMLET_SOURCE_URL_CMS;
    const backgroundImageUrl = `${gumletCDNBase}/${extractImageKey(background_image?.url)}`;
    const style = {
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
    }

    return (
        <div className={css.container} style={style}>
            <div className={css.heroSectionContent}>
                <div className={css.backToMarketplace}>
                    <IconCollection icon="icon-back" />
                    <NamedLink name="LandingPage">
                        <span><FormattedMessage id='SeriesPage.backToMarketplace' /></span>
                    </NamedLink>
                </div>
                <div>
                    <Heading className={css.title}>{title}</Heading>
                    <h3 className={css.description}>{description}</h3>
                </div>
            </div>
        </div>
    );
};

export default StreamsHero;
